module.exports = __webpack_public_path__ + "img/icon_brand_name_pre.60d912bf.png";